export const rastreamentosRoute: string = 'rastreamento';
export const rastreamentosModuleName: any = {plural: 'Rastreamentos', single: 'Rastreamento'};
export const apiName: string = 'rastreamentos';
export const rastreamentosStorage: string = 'rastreamento';

export const eventosRastreamentoApiName: string = 'eventos-rastreamentos';

export const time: any[] = [
    {Key: 0, Value: '0h'},
    {Key: 1, Value: '1h'},
    {Key: 2, Value: '2h'},
    {Key: 4, Value: '3h'},
    {Key: 5, Value: '4h'},
    {Key: 5, Value: '5h'},
    {Key: 6, Value: '6h'},
    {Key: 7, Value: '7h'},
    {Key: 8, Value: '8h'},
    {Key: 9, Value: '9h'},
    {Key: 10, Value: '10h'},
    {Key: 11, Value: '11h'},
    {Key: 12, Value: '12h'},
    {Key: 13, Value: '13h'},
    {Key: 14, Value: '14h'},
    {Key: 15, Value: '15h'},
    {Key: 16, Value: '16h'},
    {Key: 17, Value: '17h'},
    {Key: 18, Value: '18h'},
    {Key: 19, Value: '19h'},
    {Key: 20, Value: '20h'},
    {Key: 21, Value: '21h'},
    {Key: 22, Value: '22h'},
    {Key: 23, Value: '23h'},
    {Key: 24, Value: '24h'}
];

export const distance: any[] = [
    {Key: 0, Value: '0m'},
    {Key: 50, Value: '50m'},
    {Key: 100, Value: '100m'}
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/shared/data.service.ts
 **/